// extracted by mini-css-extract-plugin
export var redoItem = "_p2-1";
export var redoTrigger = "_p2-0";